import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setShippingDetails } from 'src/pages/reportUsage/redux/action/actionCreators';
import { sizes } from 'src/styles/Media.styled';
import ReplenListViewDesktop from './replenListViewDesktop/ReplenListViewDesktop';
import ReplenListViewMobile from './replenListViewMobile/ReplenListViewMobile';
import { useTranslation } from 'react-i18next';

const ReplenListView = ({ ...props }) => {
    const dispatch = useDispatch();
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);

    window.onresize = () => {
        setInnerWidth(window.innerWidth);
    };

    const { gridData, setGridData } = props;
    const {t} = useTranslation();
    const quantityInputChangeHandler = (e, idx, eventType) => {
        e.preventDefault();
        const modifiedGridData = [...gridData];
        modifiedGridData[idx].newReplenQty = isNaN(parseInt(e.target.value))
            ? ''
            : parseInt(e.target.value);
        modifiedGridData[idx].isInvalidReplenQty =
            eventType === 'blur' && !e.target.value
                ? t('productValidationMessages.mustEnterValidQty')
                : e.target.value.length > 0
                ? e.target.value === '0' || e.target.value === '00'
                    ? t('productValidationMessages.mustEnterValidQty')
                    : parseInt(e.target.value) > modifiedGridData[idx].replenQty
                    ? t('consignmentBilling.replen.replenListView.replenListViewMobile.replenishmentCannotEnterValidQty')
                    : null
                : null;
        setGridData(modifiedGridData);
        dispatch(setShippingDetails(modifiedGridData));
    };

    return (
        <>
            {innerWidth > sizes.smalDevice ? (
                <ReplenListViewDesktop
                    quantityInputChangeHandler={quantityInputChangeHandler}
                    {...props}
                />
            ) : (
                <ReplenListViewMobile
                    quantityInputChangeHandler={quantityInputChangeHandler}
                    {...props}
                />
            )}
        </>
    );
};

export default ReplenListView;
